import countries from 'i18n-iso-countries';
import deLocale from 'i18n-iso-countries/langs/de.json';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(deLocale);
countries.registerLocale(enLocale);

export type CountryLocale = 'de' | 'en';

export type CountryOption = {
  value: string;
  label: string;
};

function toCountryLocale(language: string): CountryLocale {
  return language.startsWith('en') ? 'en' : 'de';
}

export function getCountryOptions(language: string): CountryOption[] {
  const locale = toCountryLocale(language);
  const names = countries.getNames(locale, { select: 'official' });
  return Object.entries(names)
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
}

export function getCountryDisplayName(value: string | undefined, language: string): string {
  const trimmed = value?.trim() ?? '';
  if (!trimmed) {
    return '';
  }

  const locale = toCountryLocale(language);
  const upper = trimmed.toUpperCase();
  if (countries.isValid(upper)) {
    return countries.getName(upper, locale, { select: 'official' }) ?? trimmed;
  }

  return trimmed;
}
